import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuard } from './guards/auth-guard';

const routes: Routes = [
	{
		path: '404',
		component: NotFoundComponent,
	},
	{
		path: 'auth',
		loadChildren: () =>
			import('../auth/auth.module').then((mod) => mod.AuthModule),
	},
	{
		path: '',
		loadChildren: () =>
			import('../management/management.module').then(
				(mod) => mod.ManagementModule,
			),
		canActivate: [AuthGuard],
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class CoreRoutingModule {}
